// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + (chunkId === 49 ? "teacherLogin" : chunkId) + ".min.css";
};